
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2025-09-10-septa-live",
      function () {
        return require("private-next-pages/posts/2025-09-10-septa-live.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2025-09-10-septa-live"])
      });
    }
  